module.exports = __webpack_public_path__ + "img/phone.22144cb0.png";